import { SendOutlined } from "@ant-design/icons";
import { Button, Form, Input, Switch } from "antd";
import {
  getDataAnswer,
  getWordsRemain,
} from "features/private-chat/store/slice";
import { useState } from "react";
import { useSelector } from "react-redux";
import styles from "./styles.module.scss";

export type TMessages = {
  user: string;
  text: string;
  type: string;
  time: string;
};

export interface ChatFormPageInterface {
  placeholder: string;
  renderStatus: boolean;
  handleSubmit: any;
  allowPretrain?: boolean;
}

const ChatForm = (props: ChatFormPageInterface) => {
  const { renderStatus = false, placeholder, handleSubmit, allowPretrain = true } = props;
  const [chatForm] = Form.useForm();
  const { loading } = useSelector(getDataAnswer);
  const wordsRemain = useSelector(getWordsRemain);
  const [newMessage, setNewMessage] = useState("");
  const [checked, setChecked] = useState(false);

  const onSubmit = (message: string) => {
    if (!message.trim()) {
      return;
    }

    handleSubmit &&
      handleSubmit({
        answer: message,
        checked: allowPretrain ? checked : false,
      });

    setNewMessage("");
    chatForm.resetFields();
  };

  const onChange = (checked: boolean) => {
    setChecked(checked);
  };

  const handleEnter = (e: any) => {
    if (e.key === "Enter" && !e.shiftKey) {
      onSubmit(newMessage);
      e.preventDefault();
    }
  };

  return (
    <div className={styles.chat_input_box}>
      <Input.TextArea
        name="box_chat"
        maxLength={2000}
        rows={5}
        placeholder={placeholder}
        disabled={loading || renderStatus}
        value={newMessage}
        onPressEnter={(e: any) => handleEnter(e)}
        onChange={(e) => setNewMessage(e.target.value)}
        style={{ resize: "none" }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 8,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {
            allowPretrain && <>
              <Switch
                defaultChecked={checked}
                onChange={onChange}
                className={styles.ant_switch}
              />
              Use pre-trained knowledge
            </>
          }

        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {!wordsRemain ? null : (
            <span
              style={{
                marginRight: "12px",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              <span style={{ color: Number(wordsRemain.split('/')[0]) > Number(wordsRemain.split('/')[1]) ? 'red' : 'black' }}>{wordsRemain.split('/')[0]}</span>
              <span> / {wordsRemain.split('/')[1]}</span>
              <span> words</span>
            </span>
          )}
          <Button
            className={styles.button_submit}
            type="primary"
            onClick={() => onSubmit(newMessage)}
            disabled={loading || renderStatus}
          >
            Send &nbsp;
            <SendOutlined />
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ChatForm;
